export const displayParkingSpecificDetailPanelSelector = ({displayParkingSpecificDetailPanel}) => displayParkingSpecificDetailPanel